import { Routes } from "@angular/router";
import { AsapCurriculumComponent } from "./asap-curriculum.component";

export const AsapCurriculumRoutes: Routes = [
    {
        path: '',
        component: AsapCurriculumComponent
    },

];
